import { useLocation, Navigate } from "react-router-dom";
import UpiPayment from "../../components/Payment/UpiPayment";

const Pay = () => {
    const { state } = useLocation();

    if (!state) {
        return <Navigate to="/" />;
    }

    return (
        <UpiPayment
            orderId={state.orderId}
            upiId={state.upiId}
            name={state.name}
            amount={state.amount}
            intentUrl={state.intentUrl}
        />
    );
};

export default Pay;